const ABSOLUTE_URL_PATTERN: RegExp = /^[a-z][a-z0-9+.-]*:\/\//i;

const SCHEMELESS_URL_PATTERN: RegExp = /^(?:mailto|tel):/i;

/**
 * Rend utilisable dans un `href` une URL saisie librement, qui arrive de l'API sans garantie de schéma.
 * Sans schéma, le navigateur la résout comme un chemin relatif : `www.exemple.com` mène à `/fr/www.exemple.com`.
 *
 * @param value URL telle que saisie, avec ou sans schéma
 */
export const parseExternalUrl = (value: string): string => {

    const url: string = (value || '').trim();

    if (!url) {

        return null;
    }

    if (ABSOLUTE_URL_PATTERN.test(url) || SCHEMELESS_URL_PATTERN.test(url)) {

        return url;
    }

    if (url.startsWith('//')) {

        return `https:${url}`;
    }

    return `https://${url}`;
};
